console.log('🔍 Loading zh-CN translations...');

export default {
  common: {
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    add: '新增',
    search: '搜索',
    reset: '重置',
    loading: '加载中...',
    noData: '暂无数据',
    error: '错误',
    success: '成功',
    warning: '警告',
    close: '关闭',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    submit: '提交',
    export: '导出',
    import: '导入',
    refresh: '刷新',
    filter: '筛选',
    sort: '排序',
    select: '选择',
    all: '全部',
    none: '无',
    yes: '是',
    no: '否',
    enabled: '启用',
    disabled: '禁用',
    online: '在线',
    offline: '离线',
    active: '启用',
    inactive: '禁用',
    status: '状态',
    name: '名称',
    description: '描述',
    type: '类型',
    date: '日期',
    time: '时间',
    createTime: '创建时间',
    updateTime: '更新时间',
    operator: '操作员',
    remark: '备注',
    admin: '管理员',
    company: 'XXX公司',
    system: '系统',
    currentUser: '当前用户'
  },

  // 首页相关
  home: {
    title: '首页',
    welcome: '欢迎使用',
    overview: '系统概览',
    finishEdit: 'home.finishEdit',
    editHome: 'home.editHome',
    saveLayout: 'home.saveLayout',
    addCard: 'home.addCard',
    editCard: 'home.editCard',
    cardTitle: 'home.cardTitle',
    cardDescription: 'home.cardDescription',
    cardType: 'home.cardType',
    cardColor: 'home.cardColor',
    cardIcon: 'home.cardIcon',
    cardSize: 'home.cardSize'
  },

  navigation: {
    title: '导航',
    dashboard: '仪表板',
    dashboardOverview: '仪表板总览',
    dashboardPreview: '仪表板预览',
    dashboardList: '仪表板列表',
    dashboardDesign: '仪表板设计',
    deviceManagement: '设备管理',
    equipmentManagement: '设备管理',
    monitoring: '监控管理',
    applicationManagement: '应用管理',
    workflow: '流程管理',
    flow: '流程管理',
    dataPlatform: '数据管理',
    microserviceManagement: '微服务管理',
    systemManagement: '系统管理',
    profile: '个人管理',
    notifications: '通知管理',
    alarm: '警报管理',
    alarmManagement: '警报管理',
    deviceMonitoring: '设备监控',
    cctv: 'CCTV监控',
    inspectionManagement: '检查管理',
    inspectionReport: '检查报告',
    permissionManagement: '权限管理',
    userManagement: '用户管理',
    customDashboard: '自定义仪表板',
    ruleEngine: '规则引擎',
    home: '首页',
    apiManagement: 'API管理',
    apiInterface: '接口管理',
    apiModel: '物模型管理'
  },
  apiManagement: {
    apiInterface: '接口管理',
    apiModel: '物模型管理',
    interfaceTab: '接口管理',
    modelTab: '物模型管理',
    addApi: '添加API',
    addModel: '添加物模型',
    generateLib: '生成库文件',
    searchInterfaceId: '输入接口标识',
    searchInterfacePath: '输入接口路径',
    searchModule: '输入模块标识',
    module: '模块标识',
    interfaceId: '接口标识',
    url: 'URL',
    method: '请求方式',
    createdAt: '加入时间',
    updatedAt: '更新时间',
    action: '操作',
    collectorLabel: '采集器标识',
    selectCollector: '选择采集器',
    gatewayUid: '网关UID',
    selectGateway: '选择网关',
    moduleDesc: '模块说明',
    selectModule: '选择模块',
    interfaceIds: '接口标识集合',
    interfaceIdsPlaceholder: '多个接口标识以逗号分隔',
    interval: '时间间隔'
  },
  dashboard: {
    title: '仪表板',
    alertSummary: '告警工单总数量',
    todayNewAlert: '今日新增告警数',
    myTodo: '我的待办',
    processing: '办理中',
    myDone: '我的已办',
    inspectionEquipment: '巡检设备数量',
    unassigned: '未分配',
    totalDevices: '设备总数',
    onlineDevices: '在线设备',
    offlineDevices: '离线设备',
    alertDevices: '警报设备',
    systemStatus: '系统状态',
    performanceMetrics: '性能指标',
    recentAlerts: '最近警报',
    deviceStatus: '设备状态',
    systemHealth: '系统健康度',
    managementTitle: '仪表板管理',
    addDashboard: '新增仪表板',
    batchSetDefault: '批量设为默认',
    preview: '预览',
    default: '默认',
    lastModified: '最后修改',
    noDashboards: '暂无仪表板',
    createFirst: '创建您的第一个仪表板',
    confirmBatchDelete: '确认批量删除',
    editDashboard: '编辑仪表板',
    setAsDefault: '设为默认',
    fuxaUrl: 'FUXA URL'
  },
  device: {
    title: '设备管理',
    deviceList: '设备列表',
    subDevice: '子设备',
    commandManagement: '命令管理',
    addDevice: '新增设备',
    editDevice: '编辑设备',
    deviceName: '设备名称',
    deviceStatus: '设备状态',
    deviceType: '设备类型',
    deviceModel: '设备型号',
    deviceId: '设备ID',
    nodeId: '节点ID',
    protocolType: '协议类型',
    mainCircuit: '主电路',
    subCircuit: '子电路',
    commandCount: '命令数量',
    lastOnlineTime: '最后在线时间',
    deviceInfo: '设备信息',
    deviceConfig: '设备配置',
    deviceCommands: '设备命令',
    deviceHistory: '设备历史',
    deviceAlerts: '设备警报',
    deviceMaintenance: '设备维护',
    deviceLocation: '设备位置',
    deviceParameters: '设备参数',
    deviceFirmware: '设备固件',
    deviceNetwork: '设备网络',
    deviceSecurity: '设备安全',
    deviceListDescription: '查看和管理所有设备的基本信息、状态和配置',
    subDeviceManagement: '子设备管理',
    subDeviceDescription: '管理设备的子设备和相关配置',
    commandManagementDescription: '发送设备指令、查看指令历史和执行状态',
    pendingCommands: '待执行',
    deviceStatistics: '设备统计概览',
    totalDeviceCount: '总设备数',
    onlineDeviceCount: '在线设备',
    offlineDeviceCount: '离线设备',
    errorDeviceCount: '故障设备',
    nameTooLong: '名称过长'
  },
  monitoring: {
    title: '监控管理',
    realTimeMonitoring: '实时监控',
    alertManagement: '警报管理',
    alertHistory: '警报历史',
    alertRules: '警报规则',
    alertSettings: '警报设置',
    alertLevels: '警报等级',
    alertTypes: '警报类型',
    alertStatus: '警报状态',
    alertTime: '警报时间',
    alertMessage: '警报消息',
    alertSource: '警报来源',
    alertHandler: '警报处理人',
    alertPriority: '警报优先级',
    alertCategory: '警报分类',
    alertSeverity: '警报严重程度',
    alertAcknowledged: '已确认',
    alertUnacknowledged: '未确认',
    alertResolved: '已解决',
    alertPending: '待处理',
    alertProcessing: '处理中'
  },
  workflow: {
    title: '流程管理',
    ruleEngine: '规则引擎',
    workflowDesign: '流程设计',
    workflowExecution: '流程执行',
    workflowHistory: '流程历史',
    workflowTemplates: '流程模板',
    workflowRules: '流程规则',
    workflowTriggers: '流程触发器',
    workflowActions: '流程动作',
    workflowConditions: '流程条件',
    workflowVariables: '流程变量',
    workflowScheduling: '流程调度',
    workflowMonitoring: '流程监控',
    workflowAnalytics: '流程分析',
    workflowOptimization: '流程优化'
  },
  dataPlatform: {
    title: '数据管理',
    dashboard: '数据总览',
    reports: '统计报表',
    inspectionReport: '检查报告',
    source: '资料源管理',
    tasks: '数据任务'
  },

  application: {
    title: '应用管理',
    serviceOverview: '应用总览',
    fuxaConfig: 'Fuxa 配置',
    nodeRedConfig: 'Node-RED 配置'
  },

  equipment: {
    title: '设备管理',
    description: '管理系统中的所有设备和相关功能',
    equipmentList: '设备列表',
    equipmentListDescription: '查看和管理所有设备的基本信息、状态和配置',
    addEquipment: '新增设备',
    editEquipment: '编辑设备',
    equipmentDetail: '设备详情',
    commandManagement: '命令管理',
    batchEdit: '批量编辑',
    importModal: '导入模块'
  },
  flow: {
    title: '流程管理',
    description: '管理系统中的工作流程和调度',
    workflowList: '工作流程列表',
    workflowDesign: '工作流程设计',
    scheduleList: '调度列表'
  },

  rolePermission: {
    roleList: '权限管理',
    addRole: '新增角色',
    editRole: '编辑角色',
    roleDetail: '角色详情',
    roleName: '角色名称',
    roleDescription: '角色描述',
    rolePermissions: '角色权限'
  },
  positionManagement: {
    positionList: '职位列表',
    addPosition: '新增职位',
    editPosition: '编辑职位',
    positionDetail: '职位详情',
    positionName: '职位名称',
    positionDescription: '职位描述'
  },
  organizationManagement: {
    organizationList: '组织管理',
    addOrganization: '新增组织',
    editOrganization: '编辑组织',
    organizationDetail: '组织详情',
    organizationName: '组织名称',
    organizationDescription: '组织描述'
  },

  microservice: {
    pageTitle: '微服务管理',
    pageDescription: '管理 Docker 容器、Kubernetes 服务和应用堆栈',
    environment: '环境',
    deployStack: '部署堆栈',
    searchPlaceholder: '搜索容器/堆栈...',
    filterByStatus: '按状态过滤',
    filterByImage: '按镜像过滤',

    // 容器/堆栈属性
    name: '名称',
    image: '镜像',
    tag: '标签',
    statusLabel: '状态',
    ports: '端口',
    cpu: 'CPU',
    memory: '内存',
    resources: '资源使用率',
    actions: '操作',
    standalone: '独立容器',

    // 状态
    status: {
      running: '运行中',
      stopped: '已停止',
      error: '错误',
      restarting: '重启中'
    },

    // 操作按钮
    start: '启动',
    stop: '停止',
    restart: '重启',
    logs: '日志',
    monitoring: '监控',
    edit: '编辑',
    duplicate: '复制',
    delete: '删除',

    // 部署相关
    dockerCompose: 'Docker Compose',
    kubernetesYaml: 'Kubernetes YAML',
    uploadFile: '上传文件',
    composeContent: 'Compose 内容',
    composePlaceholder: '粘贴 Docker Compose 内容...',
    yamlContent: 'YAML 内容',
    yamlPlaceholder: '粘贴 Kubernetes YAML 内容...',
    selectFile: '选择文件',
    deploy: '部署',
    deploySuccess: '部署成功',
    deploySuccessMessage: '堆栈已成功部署到选定环境',
    deployError: '部署失败',
    deployErrorMessage: '部署过程中发生错误，请检查配置',

    // 日志相关
    containerLogs: '容器日志',
    autoRefresh: '自动刷新',
    downloadLogs: '下载日志',
    clearLogs: '清除日志',

    // 监控相关
    containerMonitoring: '容器监控',
    cpuUsage: 'CPU 使用率',
    memoryUsage: '内存使用率',
    networkIO: '网络 I/O',
    diskIO: '磁盘 I/O',

    // 确认对话框
    confirmDelete: '确认删除',
    deleteWarning: '确定要删除容器 "{name}" 吗？此操作无法撤销。',

    // 环境类型
    environmentTypes: {
      docker: 'Docker',
      kubernetes: 'Kubernetes'
    },

    // 容器类型
    containerTypes: {
      container: '容器',
      stack: '堆栈',
      service: '服务'
    },
    serviceOverview: '服务总览',
    fuxaConfig: 'FUXA 设置',
    nodeRedConfig: 'Node-RED 设置'
  },
  system: {
    title: '系统管理',
    globalManagement: '全域管理',
    organizationOverview: '组织总览',
    userManagement: '用户管理',
    roleManagement: '角色管理',
    permissionManagement: '权限管理',
    organizationManagement: '组织管理',
    positionManagement: '职位管理',
    systemConfig: '系统配置',
    systemLogs: '系统日志',
    systemBackup: '系统备份',
    systemRestore: '系统还原',
    systemUpdate: '系统更新',
    systemMaintenance: '系统维护',
    systemSecurity: '系统安全',
    systemPerformance: '系统性能',
    systemHealth: '系统健康度',
    systemMonitoring: '系统监控',
    rolePermission: '角色权限',
    systemSettings: '系统设置',
    activityLog: '活动日志',
    serviceLogs: '服务日志',
    loginHistory: '登录历史'
  },
  user: {
    title: '用户管理',
    username: '用户名',
    password: '密码',
    email: '电子邮件',
    phone: '电话',
    fullName: '全名',
    firstName: '名字',
    lastName: '姓氏',
    department: '部门',
    position: '职位',
    role: '角色',
    permissions: '权限',
    lastLogin: '最后登录',
    loginTime: '登录时间',
    logoutTime: '登出时间',
    loginIp: '登录IP',
    userProfile: '用户资料',
    userSettings: '用户设置',
    userPreferences: '用户偏好',
    userActivity: '用户活动',
    userSessions: '用户会话',
    systemAdmin: '系统管理员',
    maintenanceEngineer: '运维工程师',
    monitor: '监控员'
  },

  deviceMonitoring: {
    title: '设备监控',
    description: '实时监控设备状态和性能指标',
    deviceStatus: '设备状态',
    realTimeMetrics: '实时指标',
    monitorProperties: '监控属性',
    deviceStatusDescription: '查看所有设备的实时状态和基本信息',
    realTimeMetricsDescription: '监控设备的实时性能指标和数据',
    monitorPropertiesDescription: '配置监控属性和警报规则'
  },
  userManagement: {
    userList: '用户列表',
    userManagement: '用户管理',
    userName: '用户姓名',
    loginAccount: '登录账号',
    organization: '所属机构',
    organizationType: '机构类型',
    position: '岗位',
    role: '角色',
    freezeUser: '冻结用户',
    unfreezeUser: '解冻用户',
    resetPassword: '密码重置'
  },
  role: {
    title: '角色管理',
    roleName: '角色名称',
    roleDescription: '角色描述',
    rolePermissions: '角色权限',
    roleUsers: '角色用户',
    roleType: '角色类型',
    roleLevel: '角色等级',
    roleStatus: '角色状态',
    roleCreation: '角色创建',
    roleModification: '角色修改',
    roleDeletion: '角色删除',
    roleAssignment: '角色分配',
    roleRevocation: '角色撤销',
    roleInheritance: '角色继承',
    roleHierarchy: '角色层级'
  },
  organization: {
    title: '组织管理',
    organizationName: '组织名称',
    organizationCode: '组织代码',
    organizationType: '组织类型',
    organizationLevel: '组织等级',
    organizationParent: '上级组织',
    organizationChildren: '下级组织',
    organizationLeader: '组织领导',
    organizationContact: '组织联系人',
    organizationAddress: '组织地址',
    organizationPhone: '组织电话',
    organizationEmail: '组织邮箱',
    organizationWebsite: '组织网站',
    organizationDescription: '组织描述',
    organizationStatus: '组织状态',
    organizationCreation: '组织创建',
    organizationModification: '组织修改'
  },
  inspection: {
    title: '检查管理',
    inspectionSchedule: '检查排程',
    inspectionRoute: '检查路线',
    inspectionReport: '检查报告',
    inspectionTask: '检查任务',
    inspectionResult: '检查结果',
    inspectionStatus: '检查状态',
    inspectionType: '检查类型',
    inspectionFrequency: '检查频率',
    inspectionDuration: '检查时长',
    inspectionArea: '检查区域',
    inspectionEquipment: '检查设备',
    inspectionInspector: '检查员',
    inspectionDate: '检查日期',
    inspectionTime: '检查时间',
    inspectionNotes: '检查备注',
    inspectionPhotos: '检查照片',
    inspectionVideos: '检查视频',
    inspectionAlerts: '检查警报',
    inspectionMaintenance: '检查维护'
  },

  inspectionSchedule: {
    title: '巡检排班',
    routePlanning: '路线规划',
    addSchedule: '新增排班',
    editSchedule: '编辑排班',
    scheduleId: '排班编号',
    time: '时间',
    inspector: '巡检人员',
    scheduler: '排班人员',
    licensePlateNumber: '车牌号码',
    task: '任务内容',
    inspectionRoute: '巡检路线',
    actions: '操作',
    year: '年',
    month: '月',
    sunday: '日',
    monday: '一',
    tuesday: '二',
    wednesday: '三',
    thursday: '四',
    friday: '五',
    saturday: '六'
  },
  notification: {
    title: '通知管理',
    notificationCenter: '通知中心',
    notificationSettings: '通知设置',
    notificationHistory: '通知历史',
    notificationTypes: '通知类型',
    notificationChannels: '通知渠道',
    notificationTemplates: '通知模板',
    notificationRules: '通知规则',
    notificationScheduling: '通知排程',
    notificationDelivery: '通知发送',
    notificationStatus: '通知状态',
    notificationPriority: '通知优先级',
    notificationRead: '已读',
    notificationUnread: '未读',
    notificationSent: '已发送',
    notificationFailed: '发送失败',
    notificationPending: '待发送',
    notificationProcessing: '发送中',
    assignedToYou: '将工单指派给您'
  },

  notificationCenter: {
    title: '通知中心',
    description: '管理系统中的所有通知消息',
    totalNotifications: '总通知数',
    readNotifications: '已读通知',
    unreadNotifications: '未读通知',
    urgentNotifications: '紧急通知',
    addNotification: '新增通知',
    markAllAsRead: '全部标为已读',
    deleteReadNotifications: '删除已读通知',
    status: '状态',
    priority: '优先级',
    keywordSearch: '关键字搜索',
    filter: '筛选',
    notificationDetail: '通知详情',
    notificationTitle: '标题',
    content: '内容',
    targetUsers: '目标用户',
    createdAt: '创建时间',
    actions: '操作',
    editNotification: '编辑通知',
    cancel: '取消',
    update: '更新',
    add: '新增',
    close: '关闭',
    titleRequired: '标题为必填',
    contentRequired: '内容为必填',
    read: '已读',
    unread: '未读',
    low: '低',
    normal: '普通',
    high: '高',
    urgent: '紧急'
  },
  profile: {
    title: '个人管理',
    personalProfile: '个人档案',
    personalInfo: '个人资料',
    profileDescription: '其他使用者可通过公司与名称指定您',
    userName: '用户姓名',
    loginAccount: '登录账号',
    organization: '所属机构',
    organizationType: '机构类型',
    department: '部门',
    position: '职务',
    role: '角色',
    gender: '性别',
    genderMale: '男',
    genderFemale: '女',
    birthday: '生日',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    changePassword: '变更密码',
    passwordMismatch: '新密码与确认密码不一致',
    interfaceLanguage: '界面语言',
    systemTimezone: '系统时区',
    traditionalChinese: '繁体中文',
    english: 'English',
    preferences: '偏好设置',
    savePreferences: '保存偏好设置',
    resetPassword: '重设密码',
    accountSettings: '账户设置',
    securitySettings: '安全设置',
    notificationPreferences: '通知偏好',
    languageSettings: '语言设置',
    themeSettings: '主题设置',
    privacySettings: '隐私设置',
    passwordChange: '密码变更',
    emailVerification: '电子邮件验证',
    phoneVerification: '电话验证',
    twoFactorAuth: '双重认证',
    loginHistory: '登录历史',
    activityLog: '活动日志',
    dataExport: '数据导出',
    accountDeletion: '账户删除'
  },
  auth: {
    title: '认证',
    login: '登录',
    logout: '登出',
    register: '注册',
    forgotPassword: '忘记密码',
    resetPassword: '重置密码',
    changePassword: '变更密码',
    verifyEmail: '验证电子邮件',
    verifyPhone: '验证电话',
    twoFactorSetup: '双重认证设置',
    rememberMe: '记住我',
    staySignedIn: '保持登录',
    signInWith: '使用以下方式登录',
    createAccount: '创建账户',
    alreadyHaveAccount: '已有账户',
    dontHaveAccount: '没有账户',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    logoutSuccess: '登出成功',
    sessionExpired: '会话已过期',
    unauthorized: '未授权',
    forbidden: '禁止访问'
  },
  error: {
    title: '错误',
    pageNotFound: '页面未找到',
    serverError: '服务器错误',
    networkError: '网络错误',
    timeoutError: '超时错误',
    validationError: '验证错误',
    permissionError: '权限错误',
    authenticationError: '认证错误',
    authorizationError: '授权错误',
    resourceNotFound: '资源未找到',
    serviceUnavailable: '服务不可用',
    badRequest: '错误请求',
    forbidden: '禁止访问',
    internalServerError: '内部服务器错误',
    gatewayTimeout: '网关超时',
    tooManyRequests: '请求过多'
  },
  time: {
    now: '现在',
    today: '今天',
    yesterday: '昨天',
    tomorrow: '明天',
    thisWeek: '本周',
    lastWeek: '上周',
    nextWeek: '下周',
    thisMonth: '本月',
    lastMonth: '上月',
    nextMonth: '下月',
    thisYear: '今年',
    lastYear: '去年',
    nextYear: '明年',
    morning: '上午',
    afternoon: '下午',
    evening: '晚上',
    night: '夜间',
    seconds: '秒',
    minutes: '分钟',
    hours: '小时',
    days: '天',
    weeks: '周',
    months: '月',
    years: '年'
  },
  i18n: {
    title: '多国语言化测试',
    description: '这是一个用于测试多国语言化功能的页面',
    welcome: '欢迎使用多国语言化功能',
    language: '语言',
    currentLanguage: '当前语言',
    changeLanguage: '切换语言',
    languageSettings: '语言设置',
    languageSwitcher: 'languageSwitcher',
    languageCode: 'languageCode',
    languageName: 'languageName',
    currentTime: 'currentTime'
  },
  alarm: {
    title: '警报管理',
    alarmHistory: '警报历史',
    alarmRules: '警报规则',
    alarmSettings: '警报设置',
    alarmLevels: '警报等级',
    alarmTypes: '警报类型',
    alarmStatus: '警报状态',
    alarmTime: '警报时间',
    alarmMessage: '警报消息',
    alarmSource: '警报来源',
    alarmHandler: '警报处理人',
    alarmPriority: '警报优先级',
    alarmCategory: '警报分类',
    alarmSeverity: '警报严重程度',
    alarmAcknowledged: '已确认',
    alarmUnacknowledged: '未确认',
    alarmResolved: '已解决',
    alarmPending: '待处理',
    alarmProcessing: '处理中',
    alarmStatistics: '警报统计',
    alarmTrends: '警报趋势',
    alarmReports: '警报报告',
    alarmNotifications: '警报通知',
    alarmEscalation: '警报升级',
    alarmSuppression: '警报抑制',
    alarmCorrelation: '警报关联',
    alarmForecasting: '警报预测',
    alarmOptimization: '警报优化',
    // 新增子功能 key
    rules: '告警规则',
    list: '告警列表',
    templates: '告警模板',
    notifications: '告警通知'
  },

  alarmMessages: {
    title: '告警消息',
    description: '管理系统中的所有告警消息',
    totalAlarms: '总告警数',
    unprocessed: '未处理',
    processing: '处理中',
    processed: '已处理',
    refresh: '刷新',
    batchProcess: '批量处理',
    exportReport: '导出报告',
    clearProcessed: '清除已处理',
    status: '处理状态',
    priority: '优先级',
    deviceType: '设备类型',
    keywordSearch: '关键字搜索',
    filter: '筛选',
    alarmDetail: '告警详情',
    deviceSn: '设备序号',
    alarmNumber: '告警编号',
    deviceLocation: '设备位置',
    alarmValue: '告警值',
    createTime: '创建时间',
    updateTime: '更新时间',
    alarmDescription: '告警描述',
    processNote: '处理备注',
    unknown: '未知',
    noDescription: '无描述',
    startProcess: '开始处理',
    completeProcess: '完成处理',
    close: '关闭',
    batchProcessAlarm: '批量处理告警',
    selectAction: '选择操作',
    cancel: '取消',
    confirm: '确认',
    low: '低',
    normal: '普通',
    high: '高',
    critical: '紧急',
    camera: '摄像头',
    accessControl: '门禁',
    sensor: '传感器',
    controller: '控制器',
    batchMarkProcessing: '批量标记为处理中',
    batchMarkProcessed: '批量标记为已处理',
    batchDelete: '批量删除',
    actions: '操作'
  },

  integratedMonitoring: {
    title: '综合监控中心',
    description: '一站式监控管理平台 - 设备状态、环境参数、安全警报全方位监控',
    totalDevices: '设备总数',
    onlineDevices: '在线设备',
    activeAlarms: '活跃告警',
    todayAlarms: '今日告警',
    unreadNotifications: '未读通知',
    systemHealth: '系统健康度',
    realtimeAlarms: '实时告警',
    viewAll: '查看全部',
    noAlarms: '暂无告警',
    deviceStatusDistribution: '设备状态分布',
    environmentMonitoring: '环境监控',
    devicePerformanceTrend: '设备性能趋势',
    alarmTrendStatistics: '告警趋势统计',
    monitoringDataStorage: '监控数据存储管理',
    threeModuleIntegration: '三大模块整合管理',
    monitoringManagement: '监控管理'
  },

  cctv: {
    server: '服务器',
    user: '使用者',
    clearSettings: '清除设定',
    enterModifyUrl: '请输入修改网址',
    cancel: '取消',
    save: '保存'
  },

  customDashboard: {
    editorNotConfigured: '自定义仪表板编辑器未配置',
    serviceNotConfigured: '自定义仪表板服务未配置',
    checkEnvironmentVariable: '请检查环境变量 VITE_FUXA_HOST 是否已设置'
  },

  inspectionReport: {
    title: '巡检回报',
    reported: '已回报',
    notReported: '未回报',
    inspectionId: '拼接编号',
    scheduledTime: '规定巡检时间',
    actualTime: '实际巡检时间',
    inspectionPoint: '巡检点',
    taskContent: '任务内容',
    inspectionPersonnel: '巡检人员',
    status: '状态',
    reportContent: '回报内容',
    attachments: '附件',
    actions: '操作',
    abnormalId: '异常编号',
    abnormalType: '异常类型',
    abnormalContent: '异常内容',
    discoveryLocation: '发现地点',
    discoveredBy: '发现人员',
    assignedPersonnel: '指派处理人员',
    discoveryTime: '发现时间',
    completionTime: '结束时间'
  },
  deviceStatus: {
    title: '设备状态',
    description: '监控与管理所有设备的状态',
    totalDevices: '设备总数',
    onlineDevices: '在线设备',
    offlineDevices: '离线设备',
    abnormalDevices: '异常设备',
    statusDistribution: '状态分布',
    deviceTypeStats: '设备类型统计',
    refreshStatus: '刷新状态',
    exportReport: '导出报表',
    batchActions: '批量操作',
    status: '状态',
    deviceType: '设备类型',
    location: '位置',
    deviceNameSn: '设备名称/序号',
    applyFilters: '应用筛选',
    deviceDetail: '设备详情',
    deviceName: '设备名称',
    deviceSn: '设备序号',
    ipAddress: 'IP地址',
    firstOnlineTime: '首次上线时间',
    lastOnlineTime: '最后上线时间',
    deviceDescription: '设备描述',
    noDescription: '无描述',
    close: '关闭',
    chooseAction: '选择操作',
    newLocation: '新位置',
    cancel: '取消',
    confirm: '确认',
    actions: '操作',
    online: '在线',
    offline: '离线',
    abnormal: '异常',
    camera: '摄像头',
    accessControl: '门禁',
    sensor: '传感器',
    controller: '控制器',
    floor1Lobby: '一楼大堂',
    floor2Office: '二楼办公室',
    parking: '停车场',
    serverRoom: '机房',
    restart: '重启',
    updateLocation: '更新位置',
    syncTime: '同步时间'
  },
  search: {
    placeholder: '搜索功能、页面或设置...',
    searching: '搜索中...',
    noResults: '找不到相关结果',
    noResultsDesc: '请尝试使用不同的关键词，或查看下方的热门功能',
    popularFeatures: '热门功能',
    searchTips: '搜索提示',
    tip1: '使用功能名称进行搜索，如「设备管理」、「警报」',
    tip2: '使用快捷键 Ctrl+K (Windows) 或 Cmd+K (Mac) 快速打开搜索',
    tip3: '搜索结果会根据相关性自动排序',
    // 新增的 sitemap 相關 key
    frequentlyUsed: '个人常用功能',
    fullSitemap: '完整网站地图',
    categoryHome: '首页',
    categoryDashboard: '仪表板',
    categoryDevicemanagement: '设备管理',
    categoryMonitoring: '设备监控',
    categoryEquipment: '设备管理',
    categoryFlow: '流程管理',
    categoryWorkflow: '流程管理',
    categoryDataplatform: '数据管理',
    categoryData: '数据管理',
    categoryMicroservicemanagement: '微服务管理',
    categoryApimanagement: 'API管理',
    categoryInspectionmanagement: '检查管理',
    categoryNotificationmanagement: '通知管理',
    categorySystemmanagement: '系统管理',
    categorySystem: '系统管理',
    // 搜索结果描述
    dashboardDesc: '查看和管理仪表板',
    dashboardListDesc: '浏览所有仪表板列表',
    dashboardDesignDesc: '设计和编辑自定义仪表板',
    deviceMonitoringDesc: '监控设备状态和性能',
    deviceStatusDesc: '查看设备实时状态',
    realTimeMetricsDesc: '查看实时数据指标',
    equipmentManagementDesc: '管理设备和资产',
    deviceListDesc: '查看设备列表',
    flowDesc: '管理工作流程和规则',
    workflowListDesc: '查看工作流程列表',
    dataPlatformDesc: '数据平台和可视化',
    microserviceDesc: '管理微服务配置',
    apiManagementDesc: '管理 API 接口和模型',
    alarmDesc: '处理警报事件',
    inspectionReportDesc: '查看检查报告',
    systemManagementDesc: '系统设置和管理',
    // 新增缺失的翻譯鍵值
    homeDesc: '系统首页和概览',
    monitoringDesc: '设备监控和管理',
    devicemanagementDesc: '设备管理和配置',
    dataplatformDesc: '数据平台和可视化',
    microservicemanagementDesc: '微服务管理和配置',
    apimanagementDesc: 'API 接口管理',
    inspectionmanagementDesc: '检查报告管理',
    notificationmanagementDesc: '通知系统管理',
    systemmanagementDesc: '系统设置和管理',
    // 子項目描述
    navigationdashboardListDesc: '浏览所有仪表板列表',
    navigationdashboardDesignDesc: '设计和编辑自定义仪表板',
    navigationdashboardPreviewDesc: '预览仪表板效果',
    deviceMonitoringdeviceStatusDesc: '查看设备实时状态',
    deviceMonitoringrealTimeMetricsDesc: '查看实时数据指标',
    deviceMonitoringmonitorPropertiesDesc: '监控设备属性',
    devicedeviceListDesc: '查看设备列表',
    devicesubDeviceManagementDesc: '管理子设备',
    devicecommandManagementDesc: '设备命令管理',
    flowworkflowListDesc: '查看工作流程列表',
    flowworkflowDesignDesc: '设计工作流程',
    flowscheduleListDesc: '查看排程列表',
    dataPlatformdataPlatformMapDesc: '数据平台地图',
    dataPlatformdataPlatformMapboxDesc: '数据平台 Mapbox',
    dataPlatformdataPlatformLineChartDesc: '数据平台线图',
    dataPlatformdataPlatformPieChartDesc: '数据平台圆饼图',
    microserviceserviceOverviewDesc: '服务概览',
    microservicefuxaConfigDesc: 'Fuxa 配置',
    microservicenodeRedConfigDesc: 'Node-RED 配置',
    apiManagementapiInterfaceDesc: 'API 接口管理',
    apiManagementapiModelDesc: 'API 模型管理',
    alarmalarmListDesc: '警报列表',
    inspectionReportreportListDesc: '检查报告列表',
    notificationnotificationCenterDesc: '通知中心',
    notificationnotificationSettingsDesc: '通知设置',
    notificationnotificationHistoryDesc: '通知历史',
    systemglobalManagementDesc: '全局管理',
    systemconfigServiceDesc: '配置服务',
    systemmonitoringAndLogsDesc: '监控和日志',
    userManagementuserListDesc: '用户管理',
    rolePermissionroleListDesc: '角色权限管理',
    positionManagementpositionListDesc: '职位管理',
    organizationManagementorganizationListDesc: '组织管理',
    systemsystemSettingsDesc: '系统设置',
    // 其他可能遺漏的翻譯鍵值
    navigationhomeDesc: '系统首页',
    navigationdashboardDesc: '仪表板管理',
    navigationdeviceMonitoringDesc: '设备监控',
    navigationequipmentManagementDesc: '设备管理',
    navigationflowDesc: '流程管理',
    navigationdataPlatformDesc: '数据平台',
    navigationmicroserviceManagementDesc: '微服务管理',
    navigationapiManagementDesc: 'API管理',
    navigationalarmDesc: '警报管理',
    navigationinspectionReportDesc: '检查报告',
    navigationnotificationsDesc: '通知管理',
    navigationsystemManagementDesc: '系统管理',
    deviceDesc: '设备管理',
    userManagementDesc: '用户管理',
    rolePermissionDesc: '角色权限',
    positionManagementDesc: '职位管理',
    organizationManagementDesc: '组织管理'
  },

  sidebar: {
    expandAll: '展开全部',
    collapseAll: '收起全部'
  },

  footer: {
    termsOfService: '服务条款',
    privacyPolicy: '隐私政策'
  }
};
